// src/templates/TimelinePage/TimelinePage.tsx

import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'localization';
import Header from '../Header/Header';
import { SphereTimeline, useApiClients } from 'design-system/my-lib';
import { selectSphereId } from '@center-pwa/selectors/selectors';
import { setSphereId } from '@center-pwa/reducers/sphereReducer';
import type { RootState } from '@center-pwa/store/store';
import './TimelinePage.scss';

const TimelinePage: React.FC = () => {
  const { t } = useTranslation();

  // Route params
  const { sphereId } = useParams<{ sphereId: string }>();

  // Redux state
  const selectedSphereId = useSelector((state: RootState) => selectSphereId(state));
  const userLocale = useSelector((state: RootState) => state.userProfile?.locale ?? 'en-US');

  // API Clients
  const apiClients = useApiClients();

  // Dispatch
  const dispatch = useDispatch();

  /**
   * Keep Redux sphereId in sync with route param
   */
  useEffect(() => {
    if (sphereId && sphereId !== selectedSphereId) {
      dispatch(setSphereId({ sphereId, source: 'TimelinePage' }));
    }
  }, [sphereId, selectedSphereId, dispatch]);

  return (
    <div className="timeline-page">
      <Header
        sphereId={selectedSphereId}
        defaultLanguage={userLocale}
      />
      <div className="timeline-page__content">
        <div className="timeline-page__header">
          <h1 className="timeline-page__title">
            {t('timeline.page.title')}
          </h1>
          <p className="timeline-page__subtitle">
            {t('timeline.page.subtitle')}
          </p>
        </div>

        {sphereId && (
          <SphereTimeline
            sphereId={sphereId}
            apiClients={apiClients}
          />
        )}
      </div>
    </div>
  );
};

export default TimelinePage;
